import {combineReducers} from 'redux';

import {ITestReportState} from 'Admin/AdminDashboard/store/common/testReport/types';
import {communicationReducer} from 'Admin/AdminDashboard/store/common/testReport/reducer/communications';

export const testReportReducer = combineReducers<ITestReportState>({
  communications: communicationReducer
});
